module.exports = __webpack_public_path__ + "static/media/Instagram.eab59d99.svg";